import script from "./productDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./productDetail.vue?vue&type=script&setup=true&lang=js"

import "./productDetail.vue?vue&type=style&index=0&id=35830070&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35830070"]])

export default __exports__